module.exports = __webpack_public_path__ + "img/ourServiceBackgroundBottom.e4a1cea0.svg";